export function setIndex(state, index = 0) {
  state.index = index;
}

export function setItems(state, items = []) {
  state.items = [...items];
}
